export const immediateNurseConsultTrackingId = 'immediateNurseConsultTrackingPayload';
